import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { CookiesProvider } from 'react-cookie';
import Cookies from 'universal-cookie';
import 'moment/locale/pt.js';
import 'moment/locale/es.js';
import App from './App';

export default function renderAppWithProviders(store, client, eventId, req) {
  const cookieProps = req ? { cookies: new Cookies(req.headers.cookie) } : {};
  return (
    <ApolloProvider store={store} client={client}>
      <CookiesProvider {...cookieProps}>
        <App eventId={eventId} />
      </CookiesProvider>
    </ApolloProvider>
  );
}



// WEBPACK FOOTER //
// ./src/renderAppWithProviders.js